import TextField from '@mui/material/TextField';
import { Box, Button } from '@mui/material';
import { useState } from 'react';
import HttpService from '../services/HttpService';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';

function EmailRegister() {
  const validEmail = new RegExp(
    '^[\\w]+([.-]?[\\w]+)*@[\\w]+([-]?[\\w]+)*(\\.\\w{2,5}(?!\\.\\w))$'
  );
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const { enqueueSnackbar } = useSnackbar();

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
    setError(!validEmail.test(event.target.value));
  };

  const onSubmit = async () => {
    try {
      await HttpService.getAxiosClient().patch('/users/email', { email: email });
      enqueueSnackbar('Το email σας αποθηκεύτηκε επιτυχώς');
      navigate('/location');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Σφάλμα κατά την αποθήκευση του email');
    }
  };

  return (<>
    <Box display='flex'
      justifyContent='center'
      flexDirection='column'
      alignItems='center'
      gap={5}
    >
      <TextField
        style={{ width: '500px' }}
        onChange={handleEmailChange}
        value={email}
        type='email'
        helperText={error
          ? 'Λάθος email '
          : 'Καταχωρήστε το email σας για να ενημερώνεστε για την πορεία των αιτήσεων σας'}
        id='outlined-basic'
        label='Email'
        error={error}
        variant='outlined' />

      <Button onClick={onSubmit}>
        Αποθήκευση
      </Button>
    </Box>
  </>);
}

export default EmailRegister;